import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useLayout } from '../layout/context';
import { Container } from '../styled/containers';

const StyledDiv = styled.div`
  min-height: ${({ $minimumHeight }) => $minimumHeight}px;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

const Datawrapper = ({
  datawrapperID,
  altTextForFallbackImage,
  minimumHeight = 500,
}) => {
  const containerRef = useRef(null);
  const scriptAddedRef = useRef(false);
  const [scriptFailed, setScriptFailed] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  const { insideContainer, insideHalfWidth } = useLayout();

  useEffect(() => {
    if (scriptAddedRef.current) return;

    const scriptSrc = `https://datawrapper.dwcdn.net/${datawrapperID}/embed.js`;

    const script = document.createElement('script');
    script.src = scriptSrc;
    script.type = 'text/javascript';
    script.async = true;
    script.setAttribute('data-target', `#datawrapper-vis-${datawrapperID}`);

    script.onload = () => {
      setScriptLoaded(true);
    };

    script.onerror = () => {
      console.error(`Failed to load Datawrapper script: ${scriptSrc}`);
      setScriptFailed(true);
    };

    if (containerRef.current) {
      containerRef.current.appendChild(script);
      scriptAddedRef.current = true;
    }
  }, [datawrapperID]);

  return (
    <Container $padding={!(insideContainer || insideHalfWidth)}>
      <StyledDiv $minimumHeight={minimumHeight}>
        {scriptFailed && (
          <p>
            The interactive chart could not be loaded, please try again later.
          </p>
        )}
        <div id={`datawrapper-vis-${datawrapperID}`} ref={containerRef}>
          <img
            src={`https://datawrapper.dwcdn.net/${datawrapperID}/full.png`}
            alt={altTextForFallbackImage.altTextForFallbackImage}
            style={{
              objectFit: 'contain',
              display: scriptLoaded ? 'none' : 'block',
            }}
          />
        </div>
      </StyledDiv>
    </Container>
  );
};

Datawrapper.propTypes = {
  datawrapperID: PropTypes.string.isRequired,
  altTextForFallbackImage: PropTypes.string.isRequired,
  minimumHeight: PropTypes.number,
};

export default Datawrapper;

export const DatawrapperAssembly = ({ contentfulData }) => (
  <Datawrapper
    datawrapperID={contentfulData.datawrapperID}
    altTextForFallbackImage={contentfulData.altTextForFallbackImage}
    minimumHeight={contentfulData.minimumHeight}
  />
);

DatawrapperAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
